export default __webpack_public_path__ + "static/media/home1.1.d092626b.jpg";